import { Medal, Trophy } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '../../ui/avatar';

const initials = (s) => {
  const v = (s || '').trim();
  if (!v) return '?';
  const parts = v.split(/[\s._-]+/).filter(Boolean);
  return (parts.length >= 2 ? parts[0][0] + parts[1][0] : parts[0].slice(0, 2)).toUpperCase();
};

const RunnerUp = ({ label, colorClass, playersById, entries }) =>
  entries.map((s) => (
    <span key={s.playerId} className="inline-flex items-center gap-2">
      <Medal className={`h-4 w-4 ${colorClass}`} />
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
        {label}
      </span>
      {playersById[s.playerId]?.name || 'Removed player'}
    </span>
  ));

const ChampionBanner = ({ standings, playersById }) => {
  if (!standings || !standings[0]) return null;
  const champion = standings[0];
  const championPlayer = playersById[champion.playerId];
  const second = standings.filter((s) => s.rank === 2);
  const third = standings.filter((s) => s.rank === 3);

  return (
    <section className="rounded-md border border-gold/40 bg-card p-5 sm:p-6">
      <div className="flex items-center justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 text-gold">
            <Trophy className="h-6 w-6" />
            <span className="font-mono text-[10px] uppercase tracking-[0.3em]">Champion</span>
          </div>
          <h2 className="mt-2 font-display text-2xl font-semibold sm:text-3xl">
            {championPlayer?.name || 'Removed player'}
          </h2>
        </div>
        <Avatar className="hidden h-12 w-12 sm:flex">
          {championPlayer?.imageUrl && <AvatarImage src={championPlayer.imageUrl} alt="" />}
          <AvatarFallback>{initials(championPlayer?.name)}</AvatarFallback>
        </Avatar>
      </div>
      {(second.length > 0 || third.length > 0) && (
        <div className="mt-5 flex flex-wrap gap-6 text-sm">
          <RunnerUp
            label="2nd"
            colorClass="text-silver"
            playersById={playersById}
            entries={second}
          />
          <RunnerUp
            label="3rd"
            colorClass="text-bronze"
            playersById={playersById}
            entries={third}
          />
        </div>
      )}
    </section>
  );
};

export default ChampionBanner;
